export default __webpack_public_path__ + "static/media/11 BAGGAGE.652c5e26.png";